export default {
  'dynamicEntityGroup.title': 'Gestionar Grupo de Entidades Dinámicas',
  'dynamicEntityGroup.entities': 'Entidades',
};
